import React from 'react';

import styles from './app.module.css';

import { HashRouter as Router, Routes, Route, Navigate } from "react-router-dom";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Home from './pages/home';
import Company from './pages/company';
import Education from './pages/education';
import Services from './pages/services';
import Portfolio from './pages/portfolio';
import PortfolioDetail from './components/portfolio_page/portfolio/portfolio_detail/portfolio_detail';
import Hashtag from './pages/portfolio_tab';
import { Counter } from './redux/feature/counter/counter';

import NotFound from './components/not_found/not_found';
import ScrollToTop from './hooks/scroll_to_top/use_scroll_to_top';
// import TeamInfo from './components/introduction_page/team_info/team_info';


function App() {
  return (
    <div className={styles.app}>
      {/* <Router basename="jhomepage"> */}
      <Router>
        <ScrollToTop />
        <Routes>
          <Route exact path="/" element={<Home />} />
          {/* <Route path="teaminfo" element={<TeamInfo />} /> */}
          <Route exact path="company" element={<Company />} />
          <Route path="education" element={<Education />} />
          <Route path="services" element={<Services />} />
          <Route path="portfolio/farmly" element={<Navigate to="/services" replace />} />
          <Route exact path="portfolio" element={<Portfolio />} />
          <Route exact path="portfolio/:pjId" element={<PortfolioDetail />} />
          <Route exact path="hashtag" element={<Hashtag />} />
          <Route exact path="reduxtest" element={<Counter />} />
          <Route
            path="*"
            element={<NotFound />}
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;

